<app-custom-table
  [dataSource$]="dataSource$"
  titleMultipleResults="Seminare"
  titleSingleResult="Seminar"
  titleResultSuffix="verfügbar"
  [columns]="columns"
  [pageSize]="pageSize"
  [fuzzySearch]="true"
  noDataIcon="fa-book-copy"
  noDataMessage="Du hast derzeit keine Seminare verfügbar."
  noSearchResultsIcon="fa-book-copy"
  noSearchResultsMessage="Es gibt keine Kurse, die mit deinen Suchkriterien übereinstimmen."
  [filters]="filters"
  [isLoading]="isLoading"
  [headerColor]="seminarCategory?.color80"
  [borderColor]="seminarCategory?.color70"
  [pageSizeOptions]="pageSizeOptions"></app-custom-table>
